export type NotiItem = {
  id: number;
  username: string;
  prize: string;
  game: string;
};

export const NOTI_ITEMS: NotiItem[] = [
  { id: 1, username: "Taixiu***pro", prize: "200.000.000", game: "Tài xỉu khổng minh" },
  { id: 2, username: "Dragon***88", prize: "300.000.000", game: "Bắn cá Mỹ Nhân Ngư" },
  { id: 3, username: "Namkute***4", prize: "52.000.000", game: "Tài Xỉu" },
  { id: 4, username: "Tramiu***k", prize: "38.500.000", game: "Bầu Cua Mini" },
  { id: 5, username: "Hungloc***m", prize: "74.000.000", game: "Sic Bo Thiềm Thừ" },
  { id: 6, username: "Baocute***j", prize: "128.000.000", game: "Baccarat" },
  { id: 7, username: "Thinha***z", prize: "29.000.000", game: "Xóc Đĩa Mini" },
  { id: 8, username: "Linhmun***x", prize: "66.000.000", game: "Tài Xỉu MD5" },
  { id: 9, username: "Khoabe***n", prize: "91.000.000", game: "Fast & Furious" },
  { id: 10, username: "Tuanoi***w", prize: "43.000.000", game: "Bầu Cua Mini" },
  { id: 11, username: "Duonghz***p", prize: "210.000.000", game: "Tài Xỉu Khổng Minh" },
  { id: 12, username: "Trangny***q", prize: "55.000.000", game: "Đào Kim Cương" },
  { id: 13, username: "Minhcon***r", prize: "145.000.000", game: "Bạch Long Tam Thái Tử" },
  { id: 14, username: "Quanxin***s", prize: "37.500.000", game: "Đại Hải Trình" },
  { id: 15, username: "Habeo***t", prize: "310.000.000", game: "Kungfu Panda" },
  { id: 16, username: "Phucec***u", prize: "82.000.000", game: "Sic Bo Thiềm Thừ" },
  { id: 17, username: "Nhungui***v", prize: "48.000.000", game: "Tài Xỉu" },
  { id: 18, username: "Kienlem***y", prize: "163.000.000", game: "Baccarat" },
  { id: 19, username: "Huyenoi***a", prize: "71.000.000", game: "Đào Kim Cương" },
  { id: 20, username: "Datne***b", prize: "168.000.000", game: "Fast & Furious" },
  { id: 21, username: "Vancung***c", prize: "59.000.000", game: "Tài Xỉu MD5" },
  { id: 22, username: "Lamlun***d", prize: "420.000.000", game: "Tài Xỉu Khổng Minh" },
];
